// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg width=%27100%25%27 height=%27100%25%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3crect width=%27100%25%27 height=%27100%25%27 fill=%27none%27 rx=%27100%27 ry=%27100%27 stroke=%27%232A2A2AFF%27 stroke-width=%273%27 stroke-dasharray=%2712%27 stroke-dashoffset=%2786%27 stroke-linecap=%27butt%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.re-showing-calendar-container .form-header-container {
  display: flex;
  padding-bottom: 50px;
  margin-bottom: 50px;
  border-bottom: 0.5px solid var(--secondary-color-2);
  justify-content: space-between;
}
.re-showing-calendar-container .form-header-container .contents {
  display: flex;
  width: 100%;
}
.re-showing-calendar-container .form-header-container .contents .header-title {
  flex: 1 1;
  font-family: "Proxima Nova", sans-serif;
  text-align: center;
  font-size: 34px;
  font-weight: 700;
  color: var(--secondary-color-5);
  margin: 0;
}
.re-showing-calendar-container .form-header-container .contents img {
  height: 140px;
  width: 200px;
  object-fit: cover;
  border-radius: 10px;
}
.re-showing-calendar-container .form-header-container .contents .details {
  display: flex;
  flex-direction: column;
  font-family: "Proxima Nova", sans-serif;
  justify-content: space-between;
}
.re-showing-calendar-container .form-header-container .contents .details > p, .re-showing-calendar-container .form-header-container .contents .details div > p {
  margin: 0;
}
.re-showing-calendar-container .form-header-container .contents .details .id, .re-showing-calendar-container .form-header-container .contents .details .address {
  font-weight: 500;
}
.re-showing-calendar-container .form-header-container .contents .details .name, .re-showing-calendar-container .form-header-container .contents .details .price {
  font-weight: 700;
}
.re-showing-calendar-container .form-header-container .contents .details .name, .re-showing-calendar-container .form-header-container .contents .details .address {
  color: var(--secondary-color-1);
}
.re-showing-calendar-container .form-header-container .contents .details .id {
  color: var(--secondary-color-5);
  font-size: 20px;
}
.re-showing-calendar-container .form-header-container .contents .details .name {
  font-size: 24px;
}
.re-showing-calendar-container .form-header-container .contents .details .address {
  font-size: 16px;
}
.re-showing-calendar-container .form-header-container .contents .details .price {
  font-size: 22px;
  color: var(--primary-color-1);
}
.re-showing-calendar-container .form-header-container .button-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.re-showing-calendar-container .form-header-container .button-container button {
  display: flex;
  width: 200px;
  align-items: center;
  justify-content: center;
}
.re-showing-calendar-container .form-header-container .button-container button.cancel {
  background: var(--secondary-color-4);
  color: var(--secondary-color-1);
  margin-top: 10px;
}
.re-showing-calendar-container .form-header-container .button-container button.cancel:hover {
  opacity: 0.75;
}
.re-showing-calendar-container .form-header-container .button-container button.save {
  height: 100px;
  width: 100px;
  position: fixed;
  right: 250px;
  bottom: 30px;
  font-weight: 700;
  border-radius: 100%;
  z-index: 5;
  box-shadow: 0px 6px 10px 2px rgba(0, 0, 0, 0.15);
  background-color: var(--primary-color-1);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
  border-radius: 100px;
  transition: 0.3s ease-in-out;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 1;
  visibility: visible;
}
.re-showing-calendar-container .form-header-container .button-container button.save > p {
  transition: 0.3s ease-in-out;
  text-align: center;
  margin: 0;
  height: 100%;
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
.re-showing-calendar-container .form-header-container .button-container button.save > p > svg {
  position: absolute;
  top: -133px;
}
.re-showing-calendar-container .form-header-container .button-container button.save:disabled {
  background-color: var(--secondary-color-2);
  background-image: none;
  opacity: 0;
  visibility: hidden;
}
.re-showing-calendar-container .form-header-container .button-container button.save:disabled:hover {
  transform: none;
}
.re-showing-calendar-container .form-header-container .button-container button.save:disabled:hover > p {
  transform: none;
}
.re-showing-calendar-container .form-header-container .button-container button.save:hover {
  transform: rotate(30deg);
}
.re-showing-calendar-container .form-header-container .button-container button.save:hover > p {
  transform: rotate(-30deg);
}
.re-showing-calendar-container .form-header-container .compensation-concession .item {
  display: flex;
  align-items: center;
  margin-top: 10px;
  padding: 5px 10px;
  width: 200px;
  height: 30px;
  justify-content: center;
  background-color: white;
  border-radius: 5px;
  border: 1px solid var(--primary-color-1);
}
.re-showing-calendar-container .form-header-container .compensation-concession .item .no-compensation, .re-showing-calendar-container .form-header-container .compensation-concession .item .no-concession {
  font-size: 12px;
}
.re-showing-calendar-container .form-header-container .compensation-concession .item > p {
  font-family: "Proxima Nova", sans-serif;
  font-weight: 700;
  color: var(--primary-color-1);
  padding-left: 10px;
  margin: 0;
}
.re-showing-calendar-container .form-header-container .compensation-concession span.tooltip {
  position: relative;
  cursor: pointer;
}
.re-showing-calendar-container .form-header-container .compensation-concession span.tooltip:before {
  content: attr(data-text);
  position: absolute;
  top: -50px;
  left: 0px;
  width: 200px;
  padding: 10px;
  border-radius: 10px;
  background: var(--secondary-color-1);
  color: #fff;
  text-align: center;
  font-size: 12px;
  display: none;
}
.re-showing-calendar-container .form-header-container .compensation-concession span.tooltip:hover:before {
  display: block;
}`, "",{"version":3,"sources":["webpack://./src/routes/Calendar/modules/ReShowingFormCalendar/modules/FormHeader/formHeader.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,oBAAA;EACA,mBAAA;EACA,mDAAA;EACA,8BAAA;AACJ;AACI;EACI,aAAA;EACA,WAAA;AACR;AAAQ;EACI,SAAA;EACA,uCAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,SAAA;AAEZ;AAAQ;EACI,aAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;AAEZ;AAAQ;EACI,aAAA;EACA,sBAAA;EACA,uCAAA;EACA,8BAAA;AAEZ;AADY;EAAe,SAAA;AAI3B;AAHY;EACI,gBAAA;AAKhB;AAHY;EACI,gBAAA;AAKhB;AAHY;EACI,+BAAA;AAKhB;AAHY;EACI,+BAAA;EACA,eAAA;AAKhB;AAHY;EACI,eAAA;AAKhB;AAHY;EACI,eAAA;AAKhB;AAHY;EACI,eAAA;EACA,6BAAA;AAKhB;AADI;EACI,aAAA;EACA,sBAAA;EACA,8BAAA;AAGR;AAFQ;EACI,aAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;AAIZ;AAHY;EACI,oCAAA;EACA,+BAAA;EACA,gBAAA;AAKhB;AAJgB;EACI,aAAA;AAMpB;AAHY;EACI,aAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,UAAA;EACA,gDAAA;EACA,wCAAA;EACA,oEAAA;EACA,oBAAA;EACA,4BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;EACA,mBAAA;AAKhB;AAJgB;EACI,4BAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAMpB;AALoB;EACI,kBAAA;EACA,WAAA;AAOxB;AAJgB;EACI,0CAAA;EACA,sBAAA;EACA,UAAA;EACA,kBAAA;AAMpB;AALoB;EACI,eAAA;AAOxB;AANwB;EAAM,eAAA;AAS9B;AANgB;EACI,wBAAA;AAQpB;AAPoB;EACI,yBAAA;AASxB;AAEQ;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EACA,uBAAA;EACA,kBAAA;EACA,wCAAA;AAAZ;AACY;EACI,eAAA;AAChB;AACY;EACI,uCAAA;EACA,gBAAA;EACA,6BAAA;EACA,kBAAA;EACA,SAAA;AAChB;AAEQ;EACI,kBAAA;EACA,eAAA;AAAZ;AACY;EACI,wBAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,oCAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;AAChB;AACY;EACI,cAAA;AAChB","sourcesContent":[".re-showing-calendar-container .form-header-container {\n    display: flex;\n    padding-bottom: 50px;\n    margin-bottom: 50px;\n    border-bottom: 0.5px solid var(--secondary-color-2);\n    justify-content: space-between;\n    // position: relative;\n    .contents {\n        display: flex;\n        width: 100%;\n        .header-title {\n            flex: 1;\n            font-family: 'Proxima Nova', sans-serif;\n            text-align: center;\n            font-size: 34px;\n            font-weight: 700;\n            color: var(--secondary-color-5);\n            margin: 0;\n        }\n        img {\n            height: 140px;\n            width: 200px;\n            object-fit: cover;\n            border-radius: 10px;\n        }\n        .details {\n            display: flex;\n            flex-direction: column;\n            font-family: 'Proxima Nova', sans-serif;\n            justify-content: space-between;\n            > p, div > p { margin: 0; }\n            .id, .address {\n                font-weight: 500;\n            }\n            .name, .price {\n                font-weight: 700;\n            }\n            .name, .address {\n                color: var(--secondary-color-1);\n            }\n            .id {\n                color: var(--secondary-color-5);\n                font-size: 20px;\n            }\n            .name {\n                font-size: 24px;\n            }\n            .address {\n                font-size: 16px;\n            }\n            .price {\n                font-size: 22px;\n                color: var(--primary-color-1);\n            }\n        }\n    }\n    .button-container {\n        display: flex;\n        flex-direction: column;\n        justify-content: space-between;\n        button {\n            display: flex;\n            width: 200px;\n            align-items: center;\n            justify-content: center;\n            &.cancel {\n                background: var(--secondary-color-4);\n                color: var(--secondary-color-1);\n                margin-top: 10px;\n                &:hover {\n                    opacity: .75;\n                }\n            }\n            &.save {\n                height: 100px;\n                width: 100px;\n                position: fixed;\n                right: 250px;\n                bottom: 30px;\n                font-weight: 700;\n                border-radius: 100%;\n                z-index: 5;\n                box-shadow: 0px 6px 10px 2px rgba(0, 0, 0, 0.15);\n                background-color: var(--primary-color-1);\n                background-image: url(\"data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='100' ry='100' stroke='%232A2A2AFF' stroke-width='3' stroke-dasharray='12' stroke-dashoffset='86' stroke-linecap='butt'/%3e%3c/svg%3e\") !important;\n                border-radius: 100px;\n                transition: .3s ease-in-out;\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                opacity: 1;\n                visibility: visible;\n                > p { \n                    transition: .3s ease-in-out;\n                    text-align: center;\n                    margin: 0;\n                    height: 100%;\n                    width: 100%;\n                    position: relative;\n                    display: flex;\n                    align-items: center;\n                    justify-content: center;\n                    > svg {\n                        position: absolute;\n                        top: -133px;\n                    }\n                }\n                &:disabled {\n                    background-color: var(--secondary-color-2);\n                    background-image: none;\n                    opacity: 0;\n                    visibility: hidden;\n                    &:hover {\n                        transform: none;\n                        > p { transform: none; }\n                    }\n                }\n                &:hover {\n                    transform: rotate(30deg);\n                    > p {\n                        transform: rotate(-30deg);\n                    }\n                }\n            }\n        }\n    }\n    .compensation-concession {\n        // position: absolute;\n        // bottom: 25px;\n        // right: 0;\n\n        .item {\n            display: flex;\n            align-items: center;\n            margin-top: 10px;\n            padding: 5px 10px;\n            width: 200px;\n            height: 30px;\n            justify-content: center;\n            background-color: white;\n            border-radius: 5px;\n            border: 1px solid var(--primary-color-1);\n            .no-compensation, .no-concession {\n                font-size: 12px;\n            }\n            > p {\n                font-family: 'Proxima Nova', sans-serif;\n                font-weight: 700;\n                color: var(--primary-color-1);\n                padding-left: 10px;\n                margin: 0;\n            }\n        }\n        span.tooltip {\n            position: relative;\n            cursor: pointer;\n            &:before {\n                content: attr(data-text);\n                position:absolute;\n                top: -50px;\n                left: 0px;\n                width: 200px;\n                padding: 10px;\n                border-radius: 10px;\n                background:var(--secondary-color-1);\n                color: #fff;\n                text-align:center;\n                font-size: 12px;\n                display: none;\n            }\n            &:hover:before {\n                display:block;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
